export default __webpack_public_path__ + "static/media/email-icon.6bd4330e.svg";